import React, { useState } from 'react';
// import { FaSearch } from 'react-icons/fa';
import SearchIcon from '@mui/icons-material/Search';


const CLIENTS = [
    { id: 1, name: 'Liam Johnson', avatar: 'https://randomuser.me/api/portraits/men/11.jpg' },
    { id: 2, name: 'Annette Black', avatar: 'https://randomuser.me/api/portraits/women/12.jpg' },
    { id: 3, name: 'Ralph Edwards', avatar: 'https://randomuser.me/api/portraits/men/13.jpg' },
    { id: 4, name: 'Guy Hawkins', avatar: 'https://randomuser.me/api/portraits/men/14.jpg' },
];

function ClientSelector() {
    const [search, setSearch] = useState('');
    const [selected, setSelected] = useState([1, 2, 3, 4]);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleSelect = (id) => {
        setSelected((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
    };

    const filteredClients = CLIENTS.filter((c) =>
        c.name.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="w-full max-w-md mx-auto">

            <div className="relative">
                <button style={{ border: '1px solid #D0D5DD', padding: '10px 18px', fontSize: '14px', color: ' #64748B', height: '40px' }}
                    type="button"
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    className="form-select w-full  rounded text-left focus:outline-none">
                    Select Client
                </button>

                {dropdownOpen && (
                    <div className="absolute w-full mt-1 bg-white border rounded shadow-lg z-10 overflow-y-auto py-12 px-12" style={{ maxHeight: '200px' }}>
                        <div className="p-2">
                            <div className="relative" style={{
                                position: 'relative', color: '#8C8C8C', paddingBottom: '10px', borderBottom: '1px solid #D9D9D9',
                                marginBottom: '10px'
                            }}>
                                <span className="absolute left-3 top-2.5 text-sm" style={{ position: 'absolute', top: '8px', left: '18px' }}>
                                    <SearchIcon style={{ fontSize: '16px' }} />
                                </span>
                                <input style={{ padding: '0 12px 0 40px', fontSize: '14px' }}
                                    type="text"
                                    placeholder="Search Client"
                                    className="form-control w-full border rounded-pill"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                        </div>

                        <ul className="divide-y divide-gray-100">
                            {filteredClients.map((client) => (
                                <li style={{ gap: '8px', padding: '10px 12px', margin: '2px auto' }}
                                    key={client.id}
                                    className="d-flex align-items-center px-12 py-10 hover:bg-gray-100 cursor-pointer"
                                    onClick={() => toggleSelect(client.id)}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selected.includes(client.id)}
                                        onChange={() => toggleSelect(client.id)}
                                        className="form-check-input mr-3"
                                    />
                                    <img
                                        src={client.avatar}
                                        alt={client.name}
                                        className="rounded-full mr-3" style={{ width: '28px', height: '28px', borderRadius: '100px' }}
                                    />
                                    <span className="" style={{ fontSize: '12px', fontWeight: '500', color: '#000' }}>{client.name}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ClientSelector;
